import React, { useEffect, useState } from "react";
import { useApi } from "../../../../../hooks/useApi";
import Loader from "../../../../DefaultStyles/Loader";
import DefaultModalLayout from "../../../../Modal/DefaultModalLayout";
// import PartyAlarmDetail from "./PartyMailModal/PartyAlarmDetail";
import PartyAlarmList from "./PartyMailModal/PartyAlarmList";
import PartyAlarmInfo from "./PartyMailModal/PartyAlarmInfo";
import { atom, useSetRecoilState } from "recoil";
import alerteventset from "../../../../../data_json/alertevent_set.json";
import { getString3ByKey } from "../../../../../AdminApi/3.0_utils";
import { GetMoneyValue } from "../../../../../ApiTS/ApiCommonTS";
import { GetStringByKey } from "../../../../../ApiTS/ApiTranslateTS";
import styled from "styled-components";
import SpaceBetween from "../../../../DefaultStyles/SpaceBetween";
import Flex from "../../../../DefaultStyles/Flex";
import moment, { now } from "moment";
import AlertModal from "../../../../Modal/AlertModal";

interface PartyMailModalProps {
  closeEvent: () => void;
  partyid: number;
  uid: number;
}

export interface IAlarmDetail {
  id: number;
  uid: number;
  partyid: number;
  type: number;
  read: number;
  date: string;
  expire_date: string;
  msg:{
    svc_nm?: string;
    subs_nm?: string;
    user_nick?: string;
    inviteinfo?: string;
  };
  
}

export const mailRefreshState = atom({
  key: "mailRefreshState",
  default: false,
});

export default function PartyAlarmModal({
  closeEvent,
  partyid,
  uid,
}: PartyMailModalProps) {
  const [step, setStep] = useState(0);

  const [AlarmList, setAlarmList] = useState<IAlarmDetail[]>([]);

  const [expireModal, setExpireModal] = useState({
    visible: false,
    id: 0,
  });

  const [execute_List, setExecute_List] = useState(false);
  const [execute, setExecute] = useState(false);

  // 알림 리스트
  const { response: detailResponse, loading: detailLoading } = useApi({
    method: "get",
    url: execute_List
      ? `user/${uid}/alarm?&page=0&size=30&partyid=${partyid}`
      : undefined,
  });

  // 알림 만료하기
  const { response: expireResponse, loading } = useApi({
    method: "post",
    url: execute ? `party/alarm` : undefined,
    data: {
      id: expireModal.id,
    },
  });

  const [resetList, setresetList] = useState(false);

  useEffect(() => {
    setExecute_List(true);
  }, []);

  useEffect(() => {
    if (detailResponse?.status === 200) {
      const reverse = [...detailResponse?.data?.items].reverse();

      setAlarmList(reverse);
      setExecute_List(false);
    }
  }, [detailResponse, resetList]);

  useEffect(() => {
    if (expireResponse?.status === 200) {
      setExpireModal({ visible: false, id: 0 });
      setExecute_List(true);
      setExecute(false);
    }
  }, [expireResponse]);

  const getAlertData = (alertid: number) => {
    return alerteventset.find((d) => d.INDEX === alertid);
  };

  const getReplaceAutoPushData = (
    str: string,
    obj: { [key: string]: string }
  ): string => {
    if (str === "") return str;

    const regex = /{([^}]+)}/g; // 정규 표현식을 사용하여 중괄호 안의 특수 문자를 찾기

    const trimmedStr = str?.replaceAll("</ul>\r\n<ul>", "</ul><ul>");

    // replace 함수를 사용하여 특수 문자를 찾아 치환
    const resultString = trimmedStr.replace(regex, (match, p1) => {
      const key = p1.trim(); // p1은 중괄호 안의 내용, 즉 특수 문자에 해당하는 키

      const replacement = obj[key]; // replacementObject에서 키에 해당하는 값 찾기

      const needCurrency =
        key === "deposit" || key === "fst_prtprx" || key === "fst_prx";

      return replacement !== undefined
        ? needCurrency
          ? GetMoneyValue(Number(replacement))
          : replacement
        : match; // 만약 값이 존재하면 치환, 아니면 그대로 유지
    });

    return resultString;
  };

  const setDoExpire = (id: number) => {
    setExecute(true);
  };

  return (
    <DefaultModalLayout
      modalTitle={"파티 알람 리스트"}
      backBtn={step === 1 ? true : false}
      closeEvent={() => closeEvent()}
      confirmEvent={() => closeEvent()}
      cancelBtn={<></>}
      confirmBtnText="닫기"
      backBtnEvent={() => setStep(0)}
      contentPadding={step === 1 ? "10px 32px 0 32px" : undefined}
    >
      <>
        {/* step: 0 메일 목록 */}
        {step === 0 &&
          AlarmList?.map((d) => {
            if (d?.type < 10000) return;

            const notExpired =
              moment(d?.expire_date).isAfter(moment()) ||
              d?.expire_date === null
                ? true
                : false;

            return (
              <AlarmItemContainer key={d?.id}>
                <AlarmItem
                  onClick={() => {
                    if (notExpired) {
                      setExpireModal({ visible: true, id: d?.id });
                    }
                  }}
                >
                  <SpaceBetween>
                    {"* 메세지 : " +
                      getReplaceAutoPushData(
                        getString3ByKey(
                          Number(getAlertData(d?.type)?.PSH_TITLE)
                        ),
                        d?.msg
                      )}

                      {/* {d?.msg?.svc_nm? "* 서비스명 : " + d?.msg?.svc_nm : ""} */}
                      {/* {d?.msg?.subs_nm? " * 구독명 : " + d?.msg?.subs_nm : ""} */}
      
                      
                  </SpaceBetween>
                  <SpaceBetween>{"* 알람일자 : " + d?.date}</SpaceBetween>
                  <SpaceBetween>
                    {d?.read === 0 ? "* 안읽음" : "* 읽음"}
                  </SpaceBetween>
                  <SpaceBetween>
                    {d?.expire_date === null
                      ? "* 만료일자 : -"
                      : "* 만료일자 : " + d?.expire_date}
                  </SpaceBetween>
                  <SpaceBetween>
                    {notExpired ? "* 만료 전" : "* 만료"}
                  </SpaceBetween>
                </AlarmItem>
              </AlarmItemContainer>
            );
          })}

     

        {detailLoading && <Loader />}

        {expireModal.visible && (
          <AlertModal
            title={"알림을 만료하시겠습니까?"}
            btnColor="mint"
            cancelEvent={() => setExpireModal({ visible: false, id: 0 })}
            confirmEvent={() => {
              setDoExpire(expireModal.id);
            }}
          />
        )}
      </>
    </DefaultModalLayout>
  );
}

const AlarmItemContainer = styled(Flex)`
  &:not(:last-child) {
    margin-bottom: 10px;
  }
`;

const AlarmItem = styled.div`
  cursor: pointer;
  width: 100%;
  min-height: 20px;
  border-radius: 3px;
  background-color: ${({ theme }) => theme.color.bgColor};
  padding: 11px 16px;
`;
